const n = ".sl-list-group{display:flex;flex-direction:column;background:var(--sl-list-group-bg,hsl(var(--sl-hsl-card)));border:1px solid var(--sl-list-group-border-color,hsl(var(--sl-hsl-border)));border-radius:var(--sl-list-group-border-radius,var(--sl-radius-md,0.5rem));overflow:hidden}.sl-list-group--flush{border:none;border-radius:0}.sl-list-group--horizontal{flex-direction:row;flex-wrap:wrap}.sl-list-group--size-sm{--sl-list-group-item-padding:var(--sl-spacing-2,0.5rem)}.sl-list-group--size-lg{--sl-list-group-item-padding:var(--sl-spacing-6,1.5rem)}.sl-list-group-item{display:flex;align-items:center;padding:var(--sl-list-group-item-padding,var(--sl-spacing-4,1rem));margin:0;background:var(--sl-list-group-item-bg,hsl(var(--sl-hsl-card)));color:var(--sl-list-group-item-color,hsl(var(--sl-hsl-foreground)));border:none;border-bottom:1px solid var(--sl-list-group-border-color,hsl(var(--sl-hsl-border)));width:100%;text-align:left;cursor:pointer;transition:background-color var(--sl-transition-normal,200ms) ease,color var(--sl-transition-normal,200ms) ease;font:inherit}.sl-list-group-item:last-child{border-bottom:none}.sl-list-group--horizontal .sl-list-group-item{border-bottom:none;border-right:1px solid var(--sl-list-group-border-color,hsl(var(--sl-hsl-border)));flex:1;min-width:0}.sl-list-group--horizontal .sl-list-group-item:last-child{border-right:none}.sl-list-group-item:hover{background:var(--sl-list-group-item-hover-bg,hsl(var(--sl-hsl-muted)))}.sl-list-group-item--active{background:var(--sl-list-group-item-active-bg,hsl(var(--sl-hsl-primary) / 0.12));color:var(--sl-list-group-item-active-color,hsl(var(--sl-hsl-primary)));font-weight:var(--sl-font-weight-semibold,600)}.sl-list-group-item--disabled{color:var(--sl-list-group-item-disabled-color,hsl(var(--sl-hsl-muted-foreground)));cursor:not-allowed;opacity:0.6}.sl-list-group:not(.sl-list-group--horizontal) .sl-list-group-item--active:hover{background:var(--sl-list-group-item-active-bg,hsl(var(--sl-hsl-primary) / 0.12))}a.sl-list-group-item{text-decoration:none;padding-left:var(--sl-list-group-item-padding,var(--sl-spacing-4,1rem));padding-right:var(--sl-list-group-item-padding,var(--sl-spacing-4,1rem))}a.sl-list-group-item:hover{text-decoration:underline}@media (prefers-reduced-motion:reduce){.sl-list-group-item{transition:none}}";
class c extends HTMLElement {
  constructor() {
    super(), this._clickHandler = null, this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  static get observedAttributes() {
    return ["variant", "size", "bordered", "clickable"];
  }
  connectedCallback() {
    this._clickHandler = (t) => this._handleItemClick(t), this.addEventListener("click", this._clickHandler);
  }
  disconnectedCallback() {
    this._clickHandler && (this.removeEventListener("click", this._clickHandler), this._clickHandler = null);
  }
  attributeChangedCallback(t, e, s) {
    e !== s && this._render();
  }
  get variant() {
    return this.getAttribute("variant") || "default";
  }
  set variant(t) {
    this.setAttribute("variant", t);
  }
  get size() {
    return this.getAttribute("size") || "md";
  }
  set size(t) {
    this.setAttribute("size", t);
  }
  get bordered() {
    return !this.hasAttribute("bordered") || this.getAttribute("bordered") !== "false";
  }
  set bordered(t) {
    t ? this.setAttribute("bordered", "true") : this.setAttribute("bordered", "false");
  }
  get clickable() {
    return this.hasAttribute("clickable");
  }
  set clickable(t) {
    t ? this.setAttribute("clickable", "") : this.removeAttribute("clickable");
  }
  /**
   * Get the active item index.
   */
  get activeIndex() {
    return this._getItems().findIndex((e) => e.hasAttribute("active"));
  }
  /**
   * Set the active item by index.
   * @param index - Index of the item to activate
   */
  setActive(t) {
    this._getItems().forEach((s, i) => {
      i === t ? s.setAttribute("active", "") : s.removeAttribute("active");
    });
  }
  _getItems() {
    return Array.from(this.querySelectorAll("sl-list-group-item"));
  }
  _handleItemClick(t) {
    if (!this.clickable) return;
    const s = t.composedPath().find((l) => l.tagName === "SL-LIST-GROUP-ITEM");
    if (!s) return;
    const r = this._getItems().indexOf(s);
    r !== -1 && (this.setActive(r), this.dispatchEvent(
      new CustomEvent("sl-list-item-click", {
        bubbles: !0,
        composed: !0,
        detail: { index: r, item: s }
      })
    ));
  }
  _render() {
    const t = this.variant !== "default" ? ` sl-list-group--${this.variant}` : "", e = this.size !== "md" ? ` sl-list-group--size-${this.size}` : "";
    this._shadow.innerHTML = `
      <style>${n}</style>
      <div class="sl-list-group${t}${e}" ${this.clickable ? 'role="listbox"' : ""}>
        <slot></slot>
      </div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-list-group") && customElements.define("sl-list-group", c);
class u extends HTMLElement {
  static get observedAttributes() {
    return ["active", "disabled", "href", "target"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  attributeChangedCallback(t, e, s) {
    e !== s && this._render();
  }
  get active() {
    return this.hasAttribute("active");
  }
  set active(t) {
    t ? this.setAttribute("active", "") : this.removeAttribute("active");
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(t) {
    t ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  get href() {
    return this.getAttribute("href") || "";
  }
  set href(t) {
    this.setAttribute("href", t);
  }
  get target() {
    return this.getAttribute("target") || "";
  }
  set target(t) {
    this.setAttribute("target", t);
  }
  _render() {
    const t = this.active, e = this.disabled, s = this.href !== "", i = ["sl-list-group-item"];
    t && i.push("sl-list-group-item--active"), e && i.push("sl-list-group-item--disabled");
    const r = i.join(" ");
    if (s) {
      const l = t ? ' aria-selected="true"' : "", o = e ? ' aria-disabled="true"' : "", a = e ? ' style="pointer-events: none; text-decoration: line-through;"' : "";
      this._shadow.innerHTML = `
        <style>${n}</style>
        <a href="${this.href}" class="${r}" target="${this.target || "_self"}" role="option"${l}${o}${a}>
          <slot></slot>
        </a>
      `;
    } else {
      const l = t ? ' aria-selected="true"' : "", o = e ? " disabled" : "", a = e ? ' style="cursor: not-allowed;"' : "";
      this._shadow.innerHTML = `
        <style>${n}</style>
        <button type="button" class="${r}" role="listitem"${l}${o}${a}>
          <slot></slot>
        </button>
      `;
    }
  }
}
typeof customElements < "u" && !customElements.get("sl-list-group-item") && customElements.define("sl-list-group-item", u);
export {
  c as SlListGroupElement,
  u as SlListGroupItemElement
};
//# sourceMappingURL=sl-list-group.js.map
